import yup from 'src/libs/yup';

const PersonSubscriptionFilterSchema = yup.object().shape({
  person_id: yup.string().nullable().label('Pessoa'),
  subscription_id: yup.string().nullable().label('Plano'),
  status: yup.string().nullable().label('Status'),
});

export default PersonSubscriptionFilterSchema;
